// extracted by mini-css-extract-plugin
export default {"StudentDetailsScreen":"Messages_StudentDetailsScreen__vhRE5","container":"Messages_container__4Pes6","row":"Messages_row__3S+Ts"};